import { useNavigate, useParams } from "react-router";

import type { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetPlanEditPageParams = () => {
	const { hotelID, planID } = useParams<ParamParseKey<typeof PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DEFAULT>>();

	const navigate = useNavigate();
	if (!(hotelID && planID)) {
		navigate("/");
	}

	return {
		hotelID: hotelID!,
		planID: planID!,
	};
};
